module.exports = __webpack_public_path__ + "assets/images/caretaker_r.8a4e8fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/caretaker_r.png
// module id = 686
// module chunks = 1